import Seo from "@/components/Seo";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { siteText } from "@/context/SiteContext";
import { Users, HeartHandshake } from "lucide-react";

export default function Association() {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  const bureau = (settings?.bureau || []).filter((m) => m && (m.name || m.role));

  return (
    <div>
      <Seo title="L'association" description="Les Sonneurs de la Côte : une association loi 1901 qui fait vivre la cornemuse du Centre-France et le bal trad à Calais et dans le Nord-Pas-de-Calais." path="/association" />
      <section className="border-b border-stone-200 bg-[#1E1B18] py-16 text-white">
        <div className="mx-auto max-w-6xl px-4 sm:px-6">
          <span className="text-xs font-bold uppercase tracking-widest text-amber-200">{siteText(settings, "page_association_label", "Association loi 1901")}</span>
          <h1 className="mt-2 font-display text-4xl font-bold uppercase tracking-tight sm:text-6xl">{siteText(settings, "page_association_title", "L'Association")}</h1>
          <p className="mt-4 max-w-2xl text-sm leading-relaxed text-stone-300 sm:text-base">
            {siteText(settings, "page_association_intro", "Derrière les bals et les scènes, une équipe de bénévoles passionnés qui fait vivre la cornemuse et la danse traditionnelle.")}
          </p>
        </div>
      </section>

      <section className="border-b border-stone-200 bg-[#FAF6F0] py-16">
        <div className="mx-auto max-w-4xl px-4 sm:px-6">
          <div className="rounded-2xl border border-stone-200 bg-white p-8 shadow-sm sm:p-10">
            <span className="text-xs font-bold uppercase tracking-widest text-[#B83227]">Qui sommes-nous</span>
            <p data-testid="association-presentation" className="mt-4 whitespace-pre-line text-sm leading-relaxed text-stone-700 sm:text-base">
              {settings?.assoc_presentation ||
                "Les Sonneurs de la Côte est une association loi 1901 qui fait vivre la musique traditionnelle du Centre-France."}
            </p>
          </div>
        </div>
      </section>

      <section className="border-b border-stone-200 bg-white py-16">
        <div className="mx-auto max-w-6xl px-4 sm:px-6">
          <div className="mb-10 flex items-center gap-3">
            <Users className="h-6 w-6 text-[#B83227]" aria-hidden="true" />
            <h2 className="font-display text-3xl font-bold uppercase text-[#1E1B18]">Le Bureau</h2>
          </div>
          {bureau.length === 0 ? (
            <p className="rounded-xl border border-dashed border-stone-300 bg-[#FAF6F0] p-8 text-center text-sm text-stone-500">
              La composition du bureau sera présentée ici prochainement.
            </p>
          ) : (
            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
              {bureau.map((m, i) => (
                <div key={i} data-testid={`bureau-member-${i}`} className="rounded-2xl border border-stone-200 bg-[#FAF6F0] p-6 text-center shadow-sm">
                  <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-[#B83227] font-display text-xl font-bold text-white">
                    {(m.name || "?").trim().charAt(0).toUpperCase()}
                  </div>
                  <p className="font-display text-lg font-bold uppercase text-[#1E1B18]">{m.name}</p>
                  <p className="mt-1 text-xs font-bold uppercase tracking-wider text-[#B83227]">{m.role}</p>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      <section className="bg-[#1E1B18] py-16 text-white">
        <div className="mx-auto max-w-4xl px-4 sm:px-6">
          <div className="flex flex-col items-start gap-8 md:flex-row">
            <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded bg-[#B83227]">
              <HeartHandshake className="h-6 w-6" aria-hidden="true" />
            </div>
            <div>
              <h2 className="font-display text-3xl font-bold uppercase">Adhérer à l'association</h2>
              <p data-testid="association-adhesion" className="mt-4 whitespace-pre-line text-sm leading-relaxed text-stone-300">
                {settings?.assoc_adhesion ||
                  "Envie de soutenir le groupe ? Écrivez-nous via la page Contact pour connaître les modalités d'adhésion."}
              </p>
              <Link
                to="/contact"
                data-testid="association-contact-cta"
                className="mt-6 inline-block rounded bg-[#B83227] px-8 py-3.5 text-sm font-bold uppercase tracking-wider text-white shadow transition-colors duration-300 hover:bg-[#96281E]"
              >
                Nous rejoindre
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
